/*******************************************************************************
 * Project：
 * Summary:
 *　　 Define multi-selectbox component directive
 * Remarks:
 *     multi selectbox component
 * History：
 *      NghiaNX            2021/04/26    Create
 *      NghiaNX            2021/08/30    Updating to multi select -> select
 ******************************************************************************/
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Utility } from '../utility/utility';
@Component({
  selector: 'app-export-form-multi-select-box',
  templateUrl: './export-form-multi-select-box.component.html',
  styleUrls: ['./export-form-multi-select-box.component.scss']
})
export class ExportFormMultiSelectBoxComponent implements OnInit, OnChanges {
  items: any[];
  @Input() formCase = '1';
  @Input() formItems: any[];
  @Output() eventSelectValue = new EventEmitter();
  showDropDown = false;
  selectedIt: any;
  constructor(public util: Utility) {
  }

  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (!this.util.isNullOrBlank(changes.formItems) && !this.util.isNullOrBlank(changes.formItems.currentValue)) {
      if (!this.util.isNullOrBlank(this.formItems)) {
        this.initLstItem(this.formItems);
      } else {
        // ToDo api get MstForm => lstFormData
        this.initLstItem([]);
      }
    }
  }
  initLstItem(lstForm: any[]) {
    const filterForms = lstForm.filter(f => f.OutputTimingDiv === this.formCase);
    filterForms.map(m => { m.active = false; return m; });
    this.items = JSON.parse(JSON.stringify(filterForms));
  }
  checkItem(idx: number) {
    this.selectedIt = this.items[idx];
    this.shareCheckedlist();
  }
  shareCheckedlist() {
    this.showDropDown = false;
    const validForms = JSON.parse(JSON.stringify(this.selectedIt));
    this.eventSelectValue.emit(validForms);
  }
  focusSel() {
  }
}
